import http from './http';

/**
 * 用户（账户）相关接口
 */

/** 当前用户的文件列表，params: { page, limit } */
export function myFiles(params) {
  return http.get('/api/user/files', { params });
}

/** 用户列表（管理端），params: { page, search, ... } */
export function listUsers(params) {
  return http.get('/api/user/users', { params });
}

/**
 * 用户操作（action 分发式接口）
 * payload: { action: 'delete'|'create'|'resetPassword'|'regenerateAuthCode'|..., ... }
 */
export function userAction(payload) {
  return http.post('/api/user/users', payload);
}
